export default __webpack_public_path__ + "static/media/search.3bf5cd59.svg";